var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _path9, _path10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcColoredCategoryDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.353 10.4117V23.3355C22.353 26.5936 17.7909 28.0588 14.1177 28.0588C10.4446 28.0588 5.88244 26.5936 5.88244 23.3355V10.4117",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.353 10.4117V23.3355C22.353 26.5936 17.7909 28.0588 14.1177 28.0588C10.4446 28.0588 5.88244 26.5936 5.88244 23.3355V10.4117",
    stroke: "#20242E",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.353 13.9412C22.353 16.5399 18.6658 18.647 14.1177 18.647C9.57043 18.647 5.88244 16.5399 5.88244 13.9412",
    stroke: "#20242E",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.353 10.4122C22.353 12.361 18.6658 13.9411 14.1177 13.9411C9.57043 13.9411 5.88244 12.361 5.88244 10.4122C5.88244 8.46247 9.57043 6.88232 14.1177 6.88232C18.6658 6.88232 22.353 8.46247 22.353 10.4122Z",
    fill: "white",
    stroke: "#20242E",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.353 18.647C22.353 21.2458 18.6658 23.3529 14.1177 23.3529C9.57043 23.3529 5.88244 21.2458 5.88244 18.647",
    stroke: "#20242E",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0161 10.4116C20.0161 9.44271 16.7254 8.65714 14.1175 8.65714C11.5101 8.65714 8.21895 9.44271 8.21895 10.4116C8.21895 11.3809 11.5101 12.1664 14.1175 12.1664C16.7254 12.1664 20.0161 11.3809 20.0161 10.4116Z",
    fill: "#0E5CF4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.851 14.9155C27.851 14.9155 22.32 17.0294 15.4082 16.3309C16.2004 20.4317 18.5036 28.1268 22.7586 30.8754C24.7956 32.4271 29.3489 33.7793 29.3489 28.1046C31.7631 28.7696 36.4289 29.7449 39.0543 28.3263C31.4723 27.1071 28.6432 19.0163 27.851 14.9155Z",
    fill: "white",
    stroke: "#20242E",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_199_10719)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5882 26.1302L26.0198 23.7167C26.7532 23.7699 27.5222 24.1432 27.887 24.7001C28.2517 25.2571 28.103 25.8122 27.6066 26.1303M24.464 22.8355C23.6568 22.8662 22.8328 22.5096 22.468 21.9526C22.1032 21.3956 22.3438 20.8241 22.9867 20.5571L24.464 22.8355ZM22.2234 18.6517C21.9848 18.7013 21.8922 18.9198 22.0565 19.1393L22.3484 19.5782C21.1179 19.9945 20.6921 21.0705 21.4035 22.1507C22.1148 23.2309 23.6714 23.8933 25.0658 23.7806L26.7437 26.346C25.9366 26.3767 25.076 25.9694 24.6748 25.345C24.5107 25.075 24.1261 24.922 23.8508 24.9715C23.5755 25.021 23.4645 25.29 23.6469 25.56C24.3947 26.6909 25.9878 27.4207 27.3821 27.308L27.674 27.7468C27.8199 27.9663 28.1495 28.119 28.3881 28.0694C28.6267 28.0197 28.701 27.7843 28.5551 27.5649L28.2633 27.1092C29.3287 26.6585 29.6262 25.5652 28.9332 24.4851C28.2402 23.405 26.7389 22.6755 25.3999 22.7042L23.9043 20.4089C24.6195 20.4452 25.3703 20.7847 25.6803 21.2741C25.8443 21.5441 26.2106 21.7138 26.5043 21.6476C26.798 21.5813 26.8723 21.329 26.6898 21.0758C25.9965 20.063 24.55 19.4011 23.211 19.4298L22.9192 18.9741C22.7732 18.7547 22.4619 18.6189 22.2234 18.6517Z",
    fill: "#0E5CF4"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2686 31.7496C26.5058 33.1263 33.1101 33.3754 38.911 28.399",
    stroke: "#20242E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3557 10.0036L33.4722 11.0107C33.5818 11.9578 34.3135 12.7135 35.2566 12.8534V12.8534V12.8534C34.3137 12.9923 33.5818 13.7473 33.4723 14.694L33.3557 15.7014L33.2405 14.691C33.1326 13.7446 32.4006 12.9896 31.458 12.8525V12.8525V12.8525C32.4011 12.7131 33.1327 11.957 33.2408 11.0098L33.3557 10.0036Z",
    fill: "#0E5CF4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.028 0.416077L29.2756 2.46736C29.5355 4.62077 31.2098 6.33089 33.3573 6.63634V6.63634V6.63634C31.2103 6.93934 29.5355 8.64814 29.2757 10.8007L29.028 12.8526L28.7831 10.7943C28.527 8.6423 26.8522 6.93352 24.7058 6.63432V6.63432V6.63432C26.8533 6.3302 28.5272 4.6189 28.7838 2.46522L29.028 0.416077Z",
    fill: "#0E5CF4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_199_10719"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.23529,
    height: 9.41176,
    fill: "white",
    transform: "translate(21.0679 18.647) rotate(0.211122)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcColoredCategoryDefault);
export default __webpack_public_path__ + "static/media/ic-colored-category-default.623487435410cc835c0acde4b22508f8.svg";
export { ForwardRef as ReactComponent };